module.exports = __webpack_public_path__ + "img/h13.794290cd.jpg";